import { SimpleDateUtils } from "../../utils/dates";
import { StringUtils } from "../../utils/strings";

const CUSTOM_ENTRIES = {
  'impressionsCurrent': 'Current impressions',
  'impressionsReference': 'Reference impressions',
  'cpmCurrent': 'Current CPM',
  'cpmReference': 'Reference CPM',
  'revenueCurrent': 'Current revenue',
  'revenueReference': 'Reference revenue'
}

const CustomTooltip = ({ active, payload, label, totals = true}) => {
  if (active && payload && payload.length) {
    const total = payload.reduce((acc, entry) => acc + Number(entry.value), 0);
    return (
      <div className="custom-chart-tooltip">
        <p style={{fontWeight: 400}}>{SimpleDateUtils.getShoterFriendlyDate(label)}</p>
        {payload.map((entry, index) => (
          <p key={`item-${index}`} style={{ color: entry.color, padding: 0, margin: "0 auto 8px" }}>
            {CUSTOM_ENTRIES[entry.name] ? CUSTOM_ENTRIES[entry.name] : entry.name}: {StringUtils.getUSnumbersFormating(entry.value)}
          </p>
        ))}
        {totals ? <p style={{fontWeight: 600}}>Total: { StringUtils.getUSnumbersFormating(total)}</p> : null}
      </div>
    );
  }
  return null;
}

export default CustomTooltip;